/*
 * Функция для создания дублирующего заголовка
 * @example
 *  ```ts
 *   createDuplicatedString('foo', ['foo (1)', 'foo (2)', 'foo']);  // 'foo (3)'
 *   createDuplicatedString('foo', ['foo', 'foo (11)', 'foo (2)']); // 'foo (12)'
 *   createDuplicatedString('foo', ['foo', 'bar', 'baz']);          // 'foo (2)'
 *   createDuplicatedString('foo (2)', ['foo', 'bar', 'baz']);      // 'foo (3)'
 *   ```
 *
 * @param original Оригинальный заголовок
 * @param all Все заголовки
 */
export function createDuplicatedString(original: string, all: string[]): string {
    // Удаление номеров в скобках, если они есть, чтобы получить базовый заголовок
    const baseTitle = original.replace(/ \(\d+\)$/, '');
    const titleRegex = new RegExp(`^${baseTitle}( \\((\\d+)\\))?$`);

    // Собрать все подходящие заголовки и определить максимальный номер
    let maxNumber = 0;

    for (const str of all) {
        const match = str.match(titleRegex);

        if (match) {
            const currentNumber = match[2] ? parseInt(match[2], 10) : 1;

            if (currentNumber >= maxNumber) {
                maxNumber = currentNumber;
            }
        }
    }

    // Если maxNumber больше 0, значит, мы нашли похожие заголовки, и нужно создать следующий по порядку
    if (maxNumber > 0) {
        return `${baseTitle} (${maxNumber + 1})`;
    }

    // Если подходящих заголовков нет, возвращаем оригинал с (2), так как дублируем первый раз
    return `${original} (2)`;
}
